import type { Config } from "../config.contract";
import { BaseEnvironment } from "./base.environment";

export class ProductionEnvironment extends BaseEnvironment implements Config {
  /**
   * Webmotors base domain
   *
   */
  domain = "webmotors.com.br";

  /**
   * Webmotors api URL
   *
   */
  apiURL = `https://www.${this.domain}/api`;

  /**
   * Webmotors base URL
   *
   */
  baseURL = `https://www.${this.domain}`;

  /**
   * Webmotors private api URL
   *
   */
  apiPrivateURL =
    "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/prd/api";

  /**
   * SEO private api URL
   *
   */
  seoApiPrivateURL =
    "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/prd/api";

  /**
   * Cookie domain
   *
   */
  cookieDomain = [this.domain, `.${this.domain}`, `www.${this.domain}`];

  /**
   * Auth Cookie Name on production environment
   *
   */
  authCookieName = "webmotors.jwt.token";

  /**
   * Access Token Cookie Name on production environment
   *
   */
  accessTokenCookieName = "webmotors.access.token";

  /**
   * Refresh Token Cookie Name on production environment
   *
   */
  refreshTokenCookieName = "webmotors.refresh.token";

  /**
   * Vehicle photo path on PROD environment
   *
   */
  photoPath = "https://image.webmotors.com.br";

  /**
   * Webmotors chat api websocket URL
   *
   */
  chatApiUrl = "wss://chat.webmotors.com.br";

  /**
   * Adobe SDK path
   *
   */
  adobeSDK =
    "https://assets.adobedtm.com/0a9348ad03c2/c7e2a344c6e9/launch-3d19ca046842.min.js";

  /**
   * Hot deal image path on PROD environment
   *
   */
  hotDealImage = "https://image.webmotors.com.br/feiroes/imagens/prd/_portal/";

  /**
   * Seller shield image path
   */
  sellerShieldImage = "https://webmotors.com.br/img/blindagem/";

  /**
   * Login route
   *
   */
  loginRoute = `https://www.${this.domain}/login`;
}
